import payout from '@/api/accounting/payout'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        include: 'game_bettings,game_bettings.details'
      },
      attrubutes
    )
    return payout.get({ params }).then(response => {
      if(!_.isEmpty(response.data)) {
        context.commit('RECEIVE_RESOURCES', {
          data: [response.data],
          links: response.links,
          meta: response.meta
        })
      }else {
        context.commit('RECEIVE_RESOURCES', {
          data: [],
          links: response.links,
          meta: response.meta
        })
      }
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return payout.store(data)
  }
}
